import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

function Terms() {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-header">
        <Link to="/company" className="back-link">← Back to Home</Link>
      </div>

      <div className="privacy-policy-content">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last updated: Feb 2026</p>

        <section className="policy-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using Dstribute's services, you agree to be bound by these
            Terms of Service. If you do not agree to these terms, please do not use our services.
          </p>
        </section>

        <section className="policy-section">
          <h2>2. Description of Service</h2>
          <p>
            Dstribute provides an AI-powered influencer marketing platform that helps businesses
            connect with content creators and manage marketing campaigns. Our services include:
          </p>
          <ul>
            <li>Creator discovery and analytics</li>
            <li>Campaign management tools</li>
            <li>Automated outreach features</li>
            <li>Performance tracking and reporting</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. User Accounts</h2>
          <p>
            You are responsible for maintaining the confidentiality of your account credentials
            and for all activities that occur under your account. You agree to:
          </p>
          <ul>
            <li>Provide accurate and complete information</li>
            <li>Keep your login credentials secure</li>
            <li>Notify us immediately of any unauthorized access</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>4. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the service for any illegal purpose</li>
            <li>Violate any applicable laws or regulations</li>
            <li>Infringe on the rights of others</li>
            <li>Attempt to gain unauthorized access to our systems</li>
            <li>Use automated tools to scrape or collect data without permission</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>5. Intellectual Property</h2>
          <p>
            All content and materials available on Dstribute, including but not limited to
            text, graphics, logos, and software, are the property of Dstribute or its licensors
            and are protected by intellectual property laws.
          </p>
        </section>

        <section className="policy-section">
          <h2>6. Limitation of Liability</h2>
          <p>
            Dstribute shall not be liable for any indirect, incidental, special, consequential,
            or punitive damages resulting from your use of or inability to use the service.
          </p>
        </section>

        <section className="policy-section">
          <h2>7. Changes to Terms</h2>
          <p>
            We reserve the right to modify these terms at any time. We will notify users of
            any material changes by posting the updated terms on this page.
          </p>
        </section>

        <section className="policy-section">
          <h2>8. Contact Us</h2>
          <p>
            If you have any questions about these Terms of Service, please contact us at
            support@dstribute.ai.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Terms;
